import { useMemo, useState } from 'react'
import type {
  CompanyFinancialsScenarioType,
  CompanyFinancialsTrailingPeriod,
  CompanyFinancialsView,
} from '@/services/companies.service'

export interface FinancialsTableOptions {
  initialTrailingPeriod?: CompanyFinancialsTrailingPeriod
  initialView?: CompanyFinancialsView
}

export function useFinancialsTableState({
  initialTrailingPeriod,
  initialView,
}: FinancialsTableOptions) {
  const [scenarioType, setScenarioType] =
    useState<CompanyFinancialsScenarioType>('ACTUAL')
  const [trailingPeriod, setTrailingPeriod] =
    useState<CompanyFinancialsTrailingPeriod>(initialTrailingPeriod ?? 'LTM')
  const [showBlankPeriods, setShowBlankPeriods] = useState(false)
  const [view, setView] = useState<CompanyFinancialsView>(
    initialView ?? 'QUARTERLY'
  )
  const queryParams = useMemo(() => {
    const base = { scenarioType, view, trailingPeriod, showBlankPeriods }
    if (view === 'MONTHLY') return { ...base, months: 24 }
    if (view === 'QUARTERLY') return { ...base, quarters: 12 }
    return { ...base, years: 5 }
  }, [scenarioType, showBlankPeriods, trailingPeriod, view])

  return {
    scenarioType,
    setScenarioType,
    trailingPeriod,
    setTrailingPeriod,
    showBlankPeriods,
    setShowBlankPeriods,
    view,
    setView,
    queryParams,
  }
}
